module.exports = __webpack_public_path__ + "media/call.b631ec7c.wav";